import { ExtractRouteParams } from "@CommonUtils/routes";
import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";

export const RouteGetFixturesGuessing_fixturesGuessingId_ =
  "/fixtures-guessing/:fixturesGuessingId";

export type ParamsGetFixturesGuessing_fixturesGuessingId_ = ExtractRouteParams<
  typeof RouteGetFixturesGuessing_fixturesGuessingId_
>;

export type ResponseGetFixturesGuessing_fixturesGuessingId_ = {
  categoryId: number;
  storeId: number;
  fixturesGuessingPog: PogNonCircular;
};
